export default __webpack_public_path__ + "static/media/CirclePink.84e958ae.svg";